var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip",style:(_vm.styles)},[_c('div',{staticClass:"wapper"},[_c('div',{staticClass:"message"},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c('el-button',{staticClass:"reLoadBtn",attrs:{"size":"small"},on:{"click":_vm.clickHandler}},[_vm._v(_vm._s(_vm.reLoadBtnText))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }